export default "__VITE_ASSET__DAxOPDJN__"